<app-loader [ShowLoader]="globalService.showLoader"></app-loader>

<form [formGroup]="form" class="form-wrapper">
    <div class="modal-header d-flex align-items-center justify-content-between p-4">
        <div class="d-flex align-items-center justify-content-between">
            <div>
                <h3 class="mb-0" *ngIf="insertStatus">{{ 'Add'|translate}}</h3>
                <h3 class="mb-0" *ngIf="updateStatus">{{ 'Update'|translate}}</h3>
            </div>
            <div class="lang-drop-menu">
                <span>{{ 'EditTextFor'|translate }}:</span>
                <app-language-save [popupStatus]='setPopupStatus' (selectedLang)="switchLanguage($event)"></app-language-save>
            </div>
        </div>
        <button mat-dialog-close class="btn-outline modal-close modal-cancel cancel-btn"><i
        class="material-icons">close</i></button>
    </div>
    <div class="modal-body-content p-4">
        <mat-form-field class="col-lg-12 pad0">
            <mat-label>{{'Title'|translate}}</mat-label>
            <input matInput type="text" formControlName="InclusionName" placeholder="Enter name here" maxLength="40">
        </mat-form-field>
    </div>

    <div class="modal-footer-content d-flex align-items-center justify-content-end p-4">
        <a (click)="closeModal()" mat-dialog-close class="btn-outline modal-close modal-cancel cancel-btn d-flex align-items-center mr-4" [appAccessCheck]="'services'" [givenButton]="'cancel'">
            <i class="material-icons mr-1">close</i>{{'Cancel'|translate}}
        </a>
        <div>
            <a (click)="add(form)" class="waves-effect waves-light btn modal-close btn-primary modal-trigger submit-btn text-white " *ngIf="insertStatus" [appAccessCheck]="'services'" [givenButton]="'add'">{{'Submit'|translate}}</a>
            <a (click)="add(form)" class="waves-effect waves-light btn modal-close btn-primary modal-trigger submit-btn text-white" *ngIf="updateStatus" [appAccessCheck]="'services'" [givenButton]="'update'">{{'Submit'|translate}}</a>
        </div>

    </div>
</form>